module.exports = {
    AmendedBy: 'Gewijzigd door',
    AmendmentOf: 'Wijziging van',
    CccConclusions: 'Conclusies CDW',
    Documents: 'Documenten',
}